// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-active[data-v-06296f8c]{color:var(--v-primary-base)!important}[data-v-06296f8c] .v-tabs-bar{min-height:48px;height:inherit}", ""]);
// Exports
module.exports = exports;
